const permissionBasePath = '/permissions';

const PermissionConst = {
    basePath: permissionBasePath
};

export default PermissionConst;